var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("../assets/imgs/gree-shop.png"),"alt":""}}),_c('span',{staticClass:"text"},[_vm._v("啊哦~当前店铺已关闭")]),_c('div',{staticClass:"btn",on:{"click":_vm.goBackAction}},[_vm._v(" 点击返回 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }